import Coupon from './index';

export default {
    path: '/home/coupon/management',
    component: Coupon,
    children: []
}